import { ReactComponent as CardIcon } from "../../../assets/icons/card.svg";
import { ReactComponent as ToolIcon } from "../../../assets/icons/gas.svg";
import { Separator } from "../../../components/ui/common";
import DashboardCard from "../../../components/ui/dashboard/DashboardCard";
import { formatCurrency, formatCurrencyForTable } from "../../../lib/utils";
import { useGetFuelLogStatsQuery } from "../fuelLogApiSlice";

const FuelLogDashStats = () => {
  const { data, isLoading } = useGetFuelLogStatsQuery();

  const expenseStat = data?.data ?? {
    averageEfficiency: 0,
    maxFuelCost: 0,
    minFuelCost: 0,
    totalFuelCost: 0,
    totalFuelPurchased: 0,
    totalRecords: 0,
    totalFuelConsumption: 0,
  };

  const cards = [
    {
      label: "Total fuel purchased",
      value: `${formatCurrencyForTable(expenseStat.totalFuelPurchased)}`,
      icon: <ToolIcon className="h-8 w-8" />,
      index: 0,
    },
    {
      label: "Total fuel cost",
      value: `${formatCurrency(expenseStat.totalFuelCost)}`,
      icon: <CardIcon className="h-8 w-8" />,
      index: 1,
    },
    {
      label: "Total records",
      value: `${expenseStat.totalRecords}`,
      icon: <ToolIcon className="h-8 w-8" />,
      index: 2,
    },
    {
      label: "Minimum fuel cost",
      value: `${formatCurrency(expenseStat.minFuelCost)}`,
      icon: <CardIcon className="h-8 w-8" />,
      index: 3,
    },
    {
      label: "Maximum fuel cost",
      value: `${formatCurrency(expenseStat.maxFuelCost)}`,
      icon: <CardIcon className="h-8 w-8" />,
      index: 4,
    },
  ];

  return (
    <div className="flex flex-wrap gap-x-4 gap-y-4 sm:gap-x-10 sm:gap-y-6 bg-white rounded-[10px] p-4">
      {cards.map(({ label, value, icon, index }) => (
        <>
          <DashboardCard
            key={label}
            icon={icon}
            value={isLoading ? "0" : value}
            label={label}
            className="w-[300px]"
          />

          {index < cards?.length - 1 && <Separator />}
        </>
      ))}
    </div>
  );
};

export default FuelLogDashStats;
